export default __webpack_public_path__ + "static/favicon-196x196-1be9a9fa59bb06f9ae95d54037bfd427.png";